const labels = document.querySelectorAll('.label')
let packQuantity = 1
let numberOfPacks = 1
let activeProduct = document.querySelector('.titleSpan').innerHTML
let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

let quantityInput = document.querySelector('quantity-input').input
quantityInput.addEventListener("change", () => {
  numberOfPacks = quantityInput.value
  // update "Add to Cart" Button Price
  // document.querySelector('.customButton').innerHTML = `ADD TO CART - $${numberOfPacks * packQuantity * 9.99}`  
})

// update cart when "Add to Cart" is pressed
// document.querySelector('#testButton1234').addEventListener('click', () => {
  // updateCart(productIdMap[activeProduct], packQuantity * numberOfPacks)
// })

// get cart info and post new cart info based on order
const updateCart = async(key, totalQuantity) =>  {
  // submitButton.setAttribute('aria-disabled', true);
  submitButton.classList.add('loading');
  document.querySelector('.loading-overlay__spinner').classList.remove('hidden');

  let existingItems = []
  let existingQuantity = 0
  // get existing cart info first
  const res = await fetch(window.Shopify.routes.root + 'cart.js')
  existingItems = await res.json()
  existingItems.items.forEach(item => item.id == key && (existingQuantity = item.quantity))
  const updates = {}
  updates[key] = totalQuantity + existingQuantity
  // console.log(document.querySelector('#customInputTracker').value)
  // taken directly from 'product-form.js'
  const form = document.querySelector('.product-form').querySelector('form')
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  const formData = new FormData(form);
  formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
  formData.append('sections_url', window.location.pathname);
  cart.setActiveElement(document.activeElement);
  console.log(formData)
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
  .then((response) => console.log(response.json()))
  .then((response) => {
    cart.renderContents(response);
    }
  )
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {
    submitButton.classList.remove('loading');
    if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    submitButton.removeAttribute('aria-disabled');
    document.querySelector('.loading-overlay__spinner').classList.add('hidden');
  });
}


let buyButton = document.querySelector('.customButton')
let buyButtonBg = document.querySelector('.customButtonCopy')

buyButton.addEventListener('mouseover', () => {
  buyButtonBg.classList.add('hovered')
  buyButton.classList.add('hoverPaddingTop')
})

buyButton.addEventListener('mouseleave', () => {
  buyButtonBg.classList.remove('hovered')
  buyButton.classList.remove('hoverPaddingTop')
})

window.addEventListener('DOMContentLoaded', () => {
  const customButtonCopy = document.querySelector('.customButtonCopy')
  if (customButtonCopy.disabled) {
    customButtonCopy.style.color = 'transparent'
    customButtonCopy.style.background = 'transparent'
    customButtonCopy.style.border = 'transparent'

    buyButton.children[0].innerHTML = 'SOLD OUT'
  }
  
})